// https://github.com/tailwindlabs/prettier-plugin-tailwindcss?tab=readme-ov-file#sorting-classes-in-template-literals
export const tw = (
  strings: Parameters<StringConstructor['raw']>[0]['raw'],
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ...values: any[]
) => String.raw({ raw: strings }, ...values);
